<template>
  <div class="text-sm text-neutral-400">
    {{ $t('feedback.noResults') }}
    <div class="mt-2">
      <UiButton class="py-1.5 px-2" @click="emit('create', search)">
        {{ $t('feedback.quickCreate') }}
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import UiButton from './button.vue'

defineProps<{ search: string }>()

const emit = defineEmits<{ create: [term: string] }>()
</script>
